module.exports = __webpack_public_path__ + "img/6_146.ab92271a.png";